var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box tc"},[_vm._v(" 联系电话"),_c('br'),_vm._v(" 0599-6083559"),_c('br'),_vm._v(" 0599-6083558"),_c('br'),_vm._v(" 0599-6083553"),_c('br')])
}]

export { render, staticRenderFns }